module.exports = __webpack_public_path__ + "img/pokepeace_03.0a777067.png";